import { useQuery } from '@apollo/client';

import GET_CONNECTED_USER from '@graphql/auth/getConnectedUser.graphql';

export const useGetConnectedUser = () => {
  const { data, loading, error } = useQuery(GET_CONNECTED_USER);
  const connectedUser = error || loading ? null : data.getMe;
  return { connectedUser, error, loading };
};
